import { Locales } from "@caspeco/casper-ui-library";
import { Locale } from "date-fns";
import { createContext } from "react";
import { EmployeeSettings } from "../models/employee-settings";
import { SystemPermissions } from "../models/permission";
import { System } from "../models/system";
import { IsoCountryCode, User } from "../models/user";
import { CompanyProperties } from "../models/company-properties";

export type UserContext = {
	systems: System[];
	permissions: Map<string, SystemPermissions>;
	user?: User;
	employeeSettings: EmployeeSettings[];
	userLocale: { localeString: Locales; locale: Locale };
	isSupport: boolean;
	isDeveloper: boolean;
	systemCountryCode: IsoCountryCode;
	companyProperties: Map<string, CompanyProperties>;
	isImpersonating: boolean;
	canImpersonate: boolean;
	logout: () => void;
	impersonateUser: (subject: string) => void;
	stopImpersonatingUser: () => void;
};

export const UserContext = createContext<UserContext | null>(null);
